import React, {useEffect} from 'react';
import "./HeroLeft.css";
import GitHubIcon from '@material-ui/icons/GitHub';
import InstagramIcon from '@material-ui/icons/Instagram';
import FacebookIcon from '@material-ui/icons/Facebook';
import LinkedInIcon from '@material-ui/icons/LinkedIn';
import TwitterIcon from '@material-ui/icons/Twitter';

import AOS from "aos";
import "aos/dist/aos.css";

function HeroLeft() {


    useEffect(() => {
        AOS.init();
        AOS.refresh();
    }, []);


    return (
        <div className="hero-left" data-aos={"fade"} data-aos-delay="1500">
            <ul>
                <li><a href="https://github.com/Subhampreet" className="hero-social"><GitHubIcon fontSize="small" /></a></li>
                <li><a><TwitterIcon fontSize="small" /></a></li>
                <li><a href="https://www.linkedin.com/in/subhampreet-mohanty-534b9b1a9/"><LinkedInIcon fontSize="small" /></a></li>
                <li><a href="https://www.instagram.com/_the.odist_/"><InstagramIcon fontSize="small" /></a></li>
                <li><a href="https://www.facebook.com/subhampreet.mohanty/"><FacebookIcon fontSize="small" /></a></li>
            </ul>
        </div>
    )
}

export default HeroLeft

